import React from 'react';

class NotFound extends React.Component {

  render() {
    return (
      <div className='erreur404'>
        <h2>404</h2>
        <p>Oops, Page non trouvé</p>
      </div>
    );
  }
}
export default NotFound;